<template>
  <div class="flex">
    <div
      class="flex flex-col mx-auto p-4 w-full h-full items-center text-blue-800 my-4"
      style="text-align: center"
    >
      <div class="flex flex-col w-full px-12 gap-2">
        <div class="grid grid-cols-1 gap-2">
          <p class="col-span-1 text-left text-xl font-bold">
            {{ $t("blur_queue.get_bodyprints") }}
          </p>
          <div class="content-start p-4 bg-gray-200">
            <div class="w-full flex flex-row justify-between items-center">
              <div class="flex flex-row w-full gap-4">
                <div class="flex flex-col items-start flex-1 w-1/4">
                  <label
                    for="email"
                    class="block font-medium text-sm text-gray-700"
                    >{{ $t("blur_queue.input.email.label") }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <input
                      @keyup.enter="getUsers()"
                      id="email"
                      v-model="filter.email"
                      :placeholder="$t('blur_queue.input.email.placeholder')"
                      class="
                          w-full
                          h-10
                          mt-1
                          p-2
                          border-2 border-solid border-black
                          rounded-md
                          "
                    />
                  </div>
                </div>
                <div
                  v-if="showRetailers && retailers.length > 0"
                  class="flex flex-col items-start flex-1 w-1/4"
                >
                  <label
                    for="retailer"
                    class="block font-medium text-sm text-gray-700"
                    >{{ $t("blur_queue.input.retailer.label") }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <v-select
                      id="retailer"
                      v-model="selectedRetailer"
                      :options="retailers"
                      label="company_name"
                      :placeholder="
                        $t('blur_queue.input.retailer.no_selection')
                      "
                      :searchable="false"
                      @input="onRetailerSelect"
                      class="w-full mt-1 tailie-select"
                    />
                  </div>
                </div>

                <div class="flex flex-col items-start flex-1 w-1/4">
                  <label
                    for="retailer_code"
                    class="block font-medium text-sm text-gray-700"
                    >{{ $t("blur_queue.input.retailer_code.label") }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <v-select
                      id="retailer_code"
                      v-model="selectedRetailerCode"
                      :options="retailerCodes"
                      label="code"
                      :placeholder="
                        $t('blur_queue.input.retailer_code.no_selection')
                      "
                      :filterable="true"
                      @input="onRetailerCodeSelect"
                      class="w-full mt-1 tailie-select"
                    >
                      <template #no-options>
                        {{ $t("blur_queue.input.retailer_code.no_options") }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="flex flex-col items-start flex-1 w-1/4">
                  <label
                    for="status"
                    class="block font-medium text-sm text-gray-700"
                    >{{ $t("blur_queue.input.blur_status.label") }}</label
                  >
                  <div class="flex flex-row justify-center w-full">
                    <v-select
                      id="status"
                      v-model="selectedBlurStatus"
                      :options="blurStatusFilterOptions"
                      label="label"
                      :placeholder="
                        $t('blur_queue.input.blur_status.no_selection')
                      "
                      :searchable="false"
                      @input="onBlurStatusSelect"
                      class="w-full mt-1 tailie-select"
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col items-center mx-4">
                <button
                  @click="getUsers()"
                  :class="{
                    'w-24 h-10 text-md px-2 mx-2 text-white': true,
                    'bg-blue-800':
                      emailFilled ||
                      codeFilled ||
                      statusFilled ||
                      retailerFilled,
                    'bg-gray-600':
                      !emailFilled &&
                      !codeFilled &&
                      !statusFilled &&
                      !retailerFilled
                  }"
                  :disabled="
                    !emailFilled &&
                      !codeFilled &&
                      !statusFilled &&
                      !retailerFilled
                  "
                >
                  {{ $t("blur_queue.buttons.search") }}
                </button>
                <button
                  class="w-24 h-10 text-md px-3 mx-2"
                  @click="clearSearch()"
                >
                  {{ $t("blur_queue.buttons.clear") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-3 gap-4">
          <!--        Users list -->
          <div class="col-span-1 w-full border-solid border-2 self-start">
            <div v-if="usersLoading" class="p-4 text-left">
              {{ $t("blur_queue.users_table.loading") }}
            </div>

            <div v-else>
              <div class="flex items-center justify-between py-4 px-4">
                <p class="text-left font-bold">
                  {{ $t("blur_queue.users_table.header") }}
                </p>
                <button
                  class="text-sm px-2 py-1 border rounded bg-blue-800 text-white"
                  @click="userSortOrderAscending = !userSortOrderAscending"
                >
                  {{ userSortOrderAscending ? "A-Z ↑" : "Z-A ↓" }}
                </button>
              </div>
              <div v-if="users.length === 0" class="mb-4">
                {{ $t("blur_queue.users_table.no_users_found") }}
              </div>
              <div class="flex flex-col max-h-full overflow-hidden px-4">
                <div
                  class="w-full border-solid mt-3 data-table-left-section overflow-y-auto table-parent"
                >
                  <div
                    v-for="(user, index) in this.sortedUsers"
                    :key="index"
                    @click="selectedUser = user"
                    v-bind:class="[
                      'cursor-pointer hover:bg-gray-50 py-3 px-2 text-left text-sm',
                      selectedUser && selectedUser.id === user.id
                        ? 'font-bold'
                        : 'font-normal',
                      sortedUsers !== undefined &&
                      index === sortedUsers.length - 1
                        ? ''
                        : 'border-b'
                    ]"
                  >
                    {{ user.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected user info -->
          <div class="col-span-2">
            <div v-if="!selectedUser">
              <div class="border-solid border-2 p-4 text-left">
                {{ $t("blur_queue.selected_user.no_user_selected") }}
              </div>
            </div>
            <div v-else class="flex flex-col w-full gap-4">
              <div class="border-solid border-2 p-4 text-left">
                <b>{{ $t("blur_queue.selected_user.user_selected") }}</b>
                {{ selectedUser.email }}
              </div>
              <div class="border-solid border-2 p-4 text-left">
                <blur-queue-table
                  :queue-items="queueItems"
                  :queue-loading="queueLoading"
                  @handle-blur="item => requestBlurEdit(item.id)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ROUTE_BLUR_EDIT } from "@/router";
import { BlurQueueStatus } from "@/enums/modules/BlurQueueStatus";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import BlurQueueTable from "@/components/blur/blur-queue-table.vue";

export default {
  name: "BlurQueueView",
  components: {
    vSelect,
    BlurQueueTable
  },
  computed: {
    ...mapGetters({
      getAuthLoggedIn: "auth/getAuthLoggedIn",
      getAuth: "auth/getAuth",
      getUserData: "user/getUserData",
      getSidebarOpen: "layout/getSidebarOpen"
    }),
    ...mapActions(["auth/authCheck", "layout/toggleSidebar"]),
    sortedUsers() {
      const list = Array.isArray(this.users) ? [...this.users] : [];
      return list.sort((a, b) => {
        const ae = (a && a.email ? a.email : "").toString();
        const be = (b && b.email ? b.email : "").toString();
        const cmp = ae.localeCompare(be, undefined, { sensitivity: "base" });
        return !this.userSortOrderAscending ? -cmp : cmp;
      });
    }
  },
  data() {
    return {
      usersLoading: false,
      queueLoading: false,
      filter: {
        email: "",
        code: "",
        retailer: "",
        blurStatus: ""
      },
      selectedRetailerCode: null,
      selectedRetailer: null,
      selectedBlurStatus: null,
      emailFilled: false,
      codeFilled: false,
      statusFilled: false,
      retailerFilled: false,
      users: [],
      queueItems: [],
      selectedUser: null,
      retailers: [],
      retailerCodes: [],
      showRetailers: false,
      userSortOrderAscending: true,
      blurStatusFilterOptions: [
        {
          label: this.$t("blur_queue.filters.status.not_blurred"),
          value: BlurQueueStatus.NOT_BLURRED
        },
        {
          label: this.$t("blur_queue.filters.status.failed"),
          value: BlurQueueStatus.FAILED
        },
        {
          label: this.$t("blur_queue.filters.status.rejected"),
          value: BlurQueueStatus.REJECTED
        },
        {
          label: this.$t("blur_queue.filters.status.in_review"),
          value: BlurQueueStatus.IN_REVIEW
        }
      ]
    };
  },
  methods: {
    getRetailerList() {
      this.$store.dispatch("retailer/getRetailerList").then(() => {
        this.showRetailers = true;
        this.retailers = this.$store.getters["retailer/getRetailers"];
      });
    },
    getRetailerCodes() {
      this.$store.dispatch("retailer/getRetailerCodesForMeasure").then(() => {
        this.retailerCodes = this.$store.getters["retailer/getRetailerCodes"];
      });
    },
    getFilterPayload(
      email = null,
      code = null,
      retailer = null,
      blurStatus = null
    ) {
      return {
        email: email || this.filter.email,
        code: code || this.filter.code,
        retailer: retailer || this.filter.retailer,
        blurStatus: blurStatus || this.filter.blurStatus
      };
    },
    onRetailerCodeSelect(selected) {
      this.filter.code = selected ? selected.code : "";
      this.getUsers();
    },
    onRetailerSelect(selected) {
      this.filter.retailer = selected ? selected._id : "";
      this.getUsers();
    },
    onBlurStatusSelect(selected) {
      this.filter.blurStatus = selected ? selected.value : "";
      this.getUsers();
    },
    getUsers() {
      this.usersLoading = true;
      this.selectedUser = null;
      this.users = [];

      this.$store
        .dispatch("bodyprint/getAllUsersInBlurQueue", this.getFilterPayload())
        .then(() => {
          this.users = this.$store.getters["bodyprint/getUsersInBlurQueue"];
          this.usersLoading = false;
        });

      this.selectedUser =
        JSON.parse(localStorage.getItem("blurSelectedUser")) ?? null;
    },
    clearSearch() {
      this.filter.email = "";
      this.filter.code = "";
      this.filter.blurStatus = "";
      this.filter.retailer = "";

      this.selectedRetailerCode = null;
      this.selectedRetailer = null;
      this.selectedBlurStatus = null;

      this.selectedUser = null;

      localStorage.removeItem("blurSelectedUser");
      localStorage.removeItem("blurFilter");

      this.getRetailerCodes();
      this.getRetailerList();
      this.getUsers();
    },
    requestBlurEdit(id) {
      if (this.getSidebarOpen) {
        this.$store.dispatch("layout/toggleSidebar");
      }

      this.saveToLocalStorage();
      this.$router.push({
        name: ROUTE_BLUR_EDIT,
        params: { queue_id: id }
      });
    },
    saveToLocalStorage() {
      localStorage.setItem(
        "blurSelectedUser",
        JSON.stringify(this.selectedUser)
      );
      localStorage.setItem("blurFilter", JSON.stringify(this.filter));
    }
  },
  created() {
    if (!this.getSidebarOpen) {
      this.$store.dispatch("layout/toggleSidebar");
    }
    this.getRetailerCodes();
  },
  mounted() {
    this.filter = JSON.parse(localStorage.getItem("blurFilter")) ?? this.filter;
    this.selectedBlurStatus = this.blurStatusFilterOptions.filter(item => {
      return item.value === this.filter.blurStatus;
    });
    this.getUsers();
  },
  watch: {
    getUserData() {
      if (this.getUserData) {
        if (
          this.getUserData.roles.includes("admin") ||
          this.getUserData.roles.includes("employee")
        ) {
          this.getRetailerList();
        }
      }
    },

    filter: {
      handler(newFilter) {
        this.emailFilled = newFilter.email !== "";
        this.codeFilled = newFilter.code !== "";
        this.retailerFilled = newFilter.retailer !== "";
        this.statusFilled = newFilter.blurStatus !== "";
      },
      deep: true
    },

    selectedUser() {
      if (this.selectedUser) {
        this.queueLoading = true;

        this.$store
          .dispatch(
            "bodyprint/getBlurQueueForUser",
            this.getFilterPayload(this.selectedUser.email)
          )
          .then(() => {
            this.queueLoading = false;
            this.queueItems = this.$store.getters[
              "bodyprint/getItemsForBlurUser"
            ];
          });
      }
    },

    retailers() {
      this.selectedRetailer = this.retailers.filter(item => {
        return item._id === this.filter.retailer;
      });
    },
    retailerCodes() {
      this.selectedRetailerCode = this.retailerCodes.filter(item => {
        return item.code === this.filter.code;
      });
    }
  }
};
</script>
